import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import BackToAllClinics from '../BackToAllClinics';
import {
  ContentDivider,
  ContentWrapper,
  EditContent,
  EditWrapper,
  Wrapper,
} from './styles';
import EditSettingsHeader from '../EditSettingsHeader';
import ProfileAddress from '../ProfileAddress';
import { getClinicFormsList } from 'features/feature-edit-profile-settings/constants/editList';
import EditProfile from '../EditProfile';
import { fetchClinicProfile } from 'applicaiton/store/reducers/Clinics/ActionCreators';
import { useAppDispatch, useAppSelector } from 'common/hooks/redux';
import { DeleteProfileModal } from '../../../index';
import FAQs from '../FAQs';
import PaymentMethods from 'features/feature-edit-profile-settings/component/PaymentMethods';
import Schedule from '../Schedule';
import EditContacts from '../EditContacts';
import Insurances from '../Insurances';
import {
  clinicProfile,
  setProfileChanges,
} from 'applicaiton/store/reducers/Clinics/ClinicProfileSlice';
import { ClinicsForms } from 'features/feature-edit-profile-settings/constants/clinicsForms';
import { useSubscription } from 'common/hooks/useSubscription';
import SubscriptionsBlocked from 'common/components/SubscriptionsBlocked';
import SubscriptionsExpiredSoon from 'common/components/SubscriptionsExpiredSoon';
import { completeFirstLogin } from 'applicaiton/store/reducers/Users/ActionCreators';

const MainContent = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const { clinicProfileData } = useAppSelector((state) => state.clinicProfile);
  const { profile } = useAppSelector((state) => state.users);
  const clinicsFormsList = getClinicFormsList(
    Number(clinicProfileData?.owner?.id),
  );
  const [activePage, setActivePage] = useState<ClinicsForms | null>(null);
  const { isExpiredSoon, isBlocked } = useSubscription();

  useEffect(() => {
    if (!activePage) {
      setActivePage(clinicsFormsList[0]);
    }
  }, [clinicProfileData?.owner?.id]);

  useEffect(() => {
    if (id) {
      dispatch(fetchClinicProfile(String(id)));
    }
  }, [id]);

  useEffect(() => {
    if (!profile?.isFirstLoginCompleted) {
      dispatch(completeFirstLogin());
    }
  }, []);

  const handleSetNextPage = () => {
    if (activePage) {
      const findIndex = clinicsFormsList.indexOf(activePage);
      setActivePage(clinicsFormsList[findIndex + 1]);
    }
  };

  const onUnmountClearChanges = () => {
    dispatch(clinicProfile(null));
    dispatch(setProfileChanges(null));
  };

  useEffect(() => {
    return () => onUnmountClearChanges();
  }, []);

  const getCurrentScreen = () => {
    switch (activePage) {
      case ClinicsForms.Profile:
        return (
          <EditProfile
            handleSetNextPage={handleSetNextPage}
            activePage={activePage}
            setActivePage={setActivePage}
          />
        );
      case ClinicsForms.Address:
        return (
          <ProfileAddress
            handleSetNextPage={handleSetNextPage}
            activePage={activePage}
            setActivePage={setActivePage}
          />
        );
      case ClinicsForms.Contacts:
        return (
          <EditContacts
            handleSetNextPage={handleSetNextPage}
            activePage={activePage}
            setActivePage={setActivePage}
          />
        );
      case ClinicsForms.Payment:
        return (
          <PaymentMethods
            handleSetNextPage={handleSetNextPage}
            activePage={activePage}
            setActivePage={setActivePage}
          />
        );
      case ClinicsForms.Schedule:
        return (
          <Schedule
            handleSetNextPage={handleSetNextPage}
            activePage={activePage}
            setActivePage={setActivePage}
          />
        );
      case ClinicsForms.Insurance:
        return (
          <Insurances
            handleSetNextPage={handleSetNextPage}
            activePage={activePage}
            setActivePage={setActivePage}
          />
        );
      case ClinicsForms.FAQs:
        return <FAQs activePage={activePage} setActivePage={setActivePage} />;
    }
  };

  if (isBlocked) {
    return <SubscriptionsBlocked />;
  }

  return (
    <Wrapper>
      {isExpiredSoon && <SubscriptionsExpiredSoon />}
      <BackToAllClinics />
      <ContentWrapper>
        <EditSettingsHeader />
        <ContentDivider />
        <EditWrapper>
          {/*<div>*/}
          {/*<MenuList*/}
          {/*  activePage={activePage}*/}
          {/*  setActivePage={setActivePage}*/}
          {/*  clinicProfileData={clinicProfileData}*/}
          {/*/>*/}
          {/*</div>*/}
          <EditContent>{getCurrentScreen()}</EditContent>
        </EditWrapper>
      </ContentWrapper>
      <DeleteProfileModal />
    </Wrapper>
  );
};

export default MainContent;
